import {GenAIVendor} from 'common/src/modules/ai/ai.enums';
import {GenAIActionType} from './aiImages.enums';
import aiVendorIcons from './icons';

const genAIActionTypeName: Record<GenAIActionType, string> = {
  [GenAIActionType.ImageToImageMasking]: 'Image to Image Masking',
  [GenAIActionType.UpscaleImage]: 'Upscale',
  [GenAIActionType.ReplaceBackground]: 'Replace Background',
  [GenAIActionType.RemoveBackground]: 'Remove Background',
  [GenAIActionType.SketchToImage]: 'Sketch to Image',
  [GenAIActionType.TextToImage]: 'Text to Image',
  [GenAIActionType.ChatCompletion]: 'Chat Completion',
  [GenAIActionType.GetEmbeddings]: 'Get Embeddings',
  [GenAIActionType.AudioTranscription]: 'Audio Transcription',
  [GenAIActionType.TextToSpeech]: 'Text to Speech',
  [GenAIActionType.Outpainting]: 'Outpainting',
  [GenAIActionType.Inpaint]: 'Inpaint',
  [GenAIActionType.PromptToImage]: 'Prompt to Image',
  [GenAIActionType.ImageAnalysis]: 'Image Analysis',
  [GenAIActionType.PromptToImageWithReferenceImages]: 'Prompt to Image with Reference Images',
  [GenAIActionType.ExtractTextLayers]: 'Extract Text Layers',
  [GenAIActionType.ProxyResponseApi]: 'Proxy Response API',
  [GenAIActionType.EditByPrompt]: 'Edit by Prompt',
  [GenAIActionType.ResourceSelection]: 'Resource Selection',
  [GenAIActionType.AnswerGeneration]: 'Answer Generation',
  [GenAIActionType.BoundingBoxDetection]: 'Bounding Box Detection',
  [GenAIActionType.ProductShot]: 'Product Shot',
};

const genAIVendorUiName: Record<GenAIVendor, string> = {
  [GenAIVendor.OpenAI]: 'Open AI',
  [GenAIVendor.Clipdrop]: 'Clipdrop',
  [GenAIVendor.Anthropic]: 'Anthropic',
  [GenAIVendor.Google]: 'Google',
  [GenAIVendor.Runway]: 'Runway',
  [GenAIVendor.Bria]: 'Bria AI',
};

const genAIVendorIcons: Record<GenAIVendor, string> = {
  [GenAIVendor.OpenAI]: aiVendorIcons.openai,
  [GenAIVendor.Clipdrop]: aiVendorIcons.clipdrop,
  [GenAIVendor.Anthropic]: aiVendorIcons.anthropic,
  [GenAIVendor.Runway]: aiVendorIcons.runway,
  [GenAIVendor.Google]: aiVendorIcons.google,
  [GenAIVendor.Bria]: aiVendorIcons.briaai,
};

const INPAINT_LINE_COLOR = '#FA03EE';

const briaAIVendorService = 20;

export {
  genAIActionTypeName,
  genAIVendorUiName,
  genAIVendorIcons,
  INPAINT_LINE_COLOR,
  briaAIVendorService,
};
